export default {
	"reportGeneration": {
		"reportType": "ประเภทของรายงาน"
	},
	"reportList": {
		"createReport": "จัดทำรายงาน",
		"loading": "กำลังจัดทำ",
		"rangeDate": "วันที่"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/reportdownload/reportdownload.js